{
    "userDetails": {
      "controls": [
          {
            "name": "firstName",
            "label": "First Name",
            "value": "",
            "type": "text",
            "validators": {
              "required": true
            }
          },
          {
            "name": "lastName",
            "label": "Last Name",
            "value": "",
            "type": "text",
            "validators": {
                "required": true
            }
          },
          {
            "name": "orgName",
            "label": "Organization/Agency Name",
            "value": "",
            "type": "select",
                "options": [
                  {
                      "key": "Id",
                      "value": "Title"
                  }],
            "validators": {
                "required": true
            }
          },
          {
            "name": "title",
            "label": "Title",
            "value": "",
            "type": "text",
            "validators": {
                "required": true
            }
          },
          {
            "name": "phone",
            "label": "Phone Number & Extension",
            "value": "",
            "type": "text",            
            "validators": {
                "required": false
            }
          },
          {
            "name": "email",
            "label": "Email",
            "value": "",
            "type": "email",
            "placeholder": "",
            "validators": {
                "required": true,
                "email": true
            }
          },
          {
            "name": "address1",
            "label": "Mailing Street Address 1",
            "value": "",
            "type": "text", 
            "validators": {
                "required": false,
                "maxLength": 100
            }
          },
          {
            "name": "address2",
            "label": "Mailing Street Address 2",
            "value": "",
            "type": "text", 
            "validators": {
                "required": false,
                "maxLength": 50
            }
          },
          {
            "name": "city",
            "label": "Mailing Address City",
            "value": "",
            "type": "text", 
            "validators": {
                "required": false,
                "maxLength": 50
            }
          },
          {
            "name": "state",
            "label": "Mailing Address State/Territory",
            "value": "",
            "type": "select",
            "options": [],
            "validators": {
              "required": false
            }
          },
          {
            "name": "zip",
            "label": "Mailing Address Zip",
            "value": "",
            "type": "zip", 
            "validators": {
                "required": true,
                "maxLength": 10,
                "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
            }
          }
      ]
    },
    "witnessDetails": {
        "controls": [
            {
                "name": "referalType",
                "label": "Referral Type",
                "value": "",
                "type": "select",
                "options": [
                  {
                      "key": "Referal1",
                      "value": "Referal1"
                  }
              ],
                "validators": {
                  "required": true
                }
            },
            {
                "name": "involvedType",
                "label": "Primary Suspect, Subject or Involved party",
                "infoText" : "Please choose the primary subject for this dropdown field. You will be able to add more subjects later in this referral.",
                "value": "",
                "type": "select",
                "options": [
                  {
                      "key": "Member",
                      "value": "Member"
                  },
                  {
                    "key": "Provider",
                    "value": "Provider"
                  },
                  {
                    "key": "Participant",
                    "value": "Participant"
                  }
              ],
                "validators": {
                  "required": true
                }
            },
            {
                "name": "trackingNumber",
                "label": "Case, Reference or Tracking Number",
                "value": "",
                "type": "text",
                "validators": {
                  "required": true,
                  "maxLength": 110
                }
            },
            {
                "name": "detected",
                "label": "How was this detected?",
                "value": "",
                "type": "textarea",
                "options": {
                  "showCount": true,
                  "count": 0
                },
                "validators": {
                  "required": true,
                  "maxLength": 4000
                }
            },
            {
                "name": "estimatedAmount",
                "label": "Estimated Amount of Money Involved",
                "value": "",
                "type": "currency",
                "placeholder": "Enter a Dollar Amount",
                "validators": {}
            },
            {
                "name": "originalDetectionDt",
                "label": "Original Detection Date",
                "value": "",
                "type": "date",
                "options": {
                  "min": "2000-01-01",
                  "max": "2100-01-01"
                },
                "validators": {}
            },
            {
                "name": "incidentStartDt",
                "label": "Incident Start Date (i.e., First Date of Service)",
                "value": "",
                "type": "date",
                "options": {
                  "min": "2000-01-01",
                  "max": "2100-01-01"
                },
                "validators": {}
            },
            {
                "name": "incidentEndDt",
                "label": "Incident End Date (i.e., Last Date of Service)",
                "value": "",
                "type": "date",
                "options": {
                  "min": "2000-01-01",
                  "max": "2100-01-01"
                },
                "validators": {}
            },
            {
                "name": "state",
                "label": "State/Territory Where Incident Occurred",
                "value": "",
                "type": "select",
                "options": [
                    {
                        "key": "Texas",
                        "value": "Texas"
                    }
                ],
                "validators": {}
            },
            {
              "name": "county",
              "label": "County/District Where Incident Occurred",
              "value": "",
              "type": "select",  
              "options": [],      
              "validators": {}
            },
            {
              "name": "referralSummary",
              "label": "Please Provide a Summary of this Referral",
              "value": "",
              "type": "textarea",
              "infoText" : "(Describe any issue(s) or allegation(s), including details such as the involved procedure/device and diagnoses codes with descriptions, violation(s) of regulations or policy, etc.)",
              "options": {
                "showCount": true,
                "count": 0,
                "helpText" : "(Describe any issue(s) or allegation(s), including details such as the involved procedure/device and diagnoses codes with descriptions, violation(s) of regulations or policy, etc.)"
              },
              "validators": {
                "required": true,
                "maxLength": 15000
              }
            },
            {
              "name": "associatedLeadReasonId",
              "label": "",
              "value": "",
              "type": "hidden",
              "validators": {
                "required": false
              }
            }
        ]
    },
    "involvedParties": {
      "data": [
        {
          "Id": 1,
          "isPrimary": true,
          "involvedPartyId": "",
          "subjectTypeKey": "",
          "subjectType": "",
          "profileMasterTypeKey": "",
          "organization": "",
          "isExternalReferal": false,
          "externalReferalReport": "",
          "externalReferalAddInfo": "",
          "formControlDetails": []
        }
      ],
      "controls": [
        {
          "name": "isAnotherInvolvedParty",
          "label": "Is there another involved party?",
          "value": "",
          "type": "select",
          "options": [
              {
                  "key": "Yes",
                  "value": "Yes"
              },
              {
                "key": "No",
                "value": "No"
              }
            ],
          "validators": {
            "required": true
          }
        },
        {
          "name": "additionalInvolvedType",
          "label": "Please select the additional involved party type",
          "value": "",
          "type": "select",
          "options": [
            {
                "key": "Member",
                "value": "Member"
            },
            {
              "key": "Provider",
              "value": "Provider"
            },
            {
              "key": "Participant",
              "value": "Participant"
            }
          ],
          "validators": {
            "required": true
          }
        },
        {
          "name": "isAnotherExternalInvolvedParty",
          "label": "Is this involved party an external referring party or witness?",
          "value": "",
          "type": "select",
          "options": [
              {
                  "key": "Yes",
                  "value": "Yes"
              },
              {
                "key": "No",
                "value": "No"
              }
            ],
          "validators": {
            "required": true
          }
        },
        {
          "name": "externalReferalReport",
          "label": "How did this witness/external referring party report this?",
          "value": "",
          "type": "textarea",
          "options": {
            "showCount": false,
            "count": 0
          },
          "validators": {
            "required": true
          }
        },
        {
          "name": "externalReferalAddInfo",
          "label": "Any Additonal Information regarding the witness or external referring party?",
          "value": "",
          "type": "textarea",
          "optional": true,
          "options": {
            "showCount": false,
            "count": 0
          },
          "validators": {
          }
        }
      ]
    },
    "extenalReferall": {
      "controls": [
        {
          "name": "isExternalReferal",
          "label": "Is this involved party an external referring party or witness?",
          "value": "",
          "type": "select",
          "options": [
              {
                  "key": "Yes",
                  "value": "Yes"
              },
              {
                "key": "No",
                "value": "No"
              }
            ],
          "validators": {
            "required": true
          }
        },
        {
          "name": "externalReferalReport",
          "label": "How did this witness/external referring party report this?",
          "value": "",
          "type": "textarea",
          "options": {
            "showCount": false,
            "count": 0
          },
          "validators": {
            "required": true
          }
        },
        {
          "name": "externalReferalAddInfo",
          "label": "Any Additonal Information regarding the witness or external referring party?",
          "value": "",
          "type": "textarea",
          "optional": true,
          "options": {
            "showCount": false,
            "count": 0
          },
          "validators": {
          }
        }
      ],
      "subcontrols": [
        {
          "name": "wFirstName",
          "label": "First Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": true
          }
        },
        {
          "name": "wLastName",
          "label": "Last Name",
          "value": "",
          "type": "text",
          "validators": {
              "required": true
          }
        },
        {
          "name": "wAgencyName",
          "label": "Organization/Agency Name",
          "value": "",
          "type": "text",
          "validators": {
              "required": true
          }
        },
        {
          "name": "wRelationShip",
          "label": "Referring Party’s Relationship to the Involved Party (i.e., Patient)",
          "value": "",
          "type": "text",
          "validators": {
              "required": true
          }
        },
        {
          "name": "phone",
          "label": "Phone Number & Extension",
          "value": "",
          "type": "text",
          "validators": {
              "required": false
          }
        },
        {
          "name": "email",
          "label": "Email",
          "value": "",
          "type": "email",
          "placeholder":"name@example.com",
          "validators": {
              "email": true
          }
        },
        {
          "name": "wAddress1",
          "label": "Street Address Line 1",
          "value": "",
          "type": "text",
          "validators": {
          }
        },
        {
          "name": "wAddress2",
          "label": "Street Address Line 2",
          "value": "",
          "type": "text",
          "validators": {
          }
        },
        {
          "name": "city",
          "label": "City",
          "value": "",
          "type": "text",
          "validators": {
          }
        },
        {
          "name": "state",
          "label": "State/Territory",
          "value": "",
          "type": "select",
          "options": [
              {
                  "key": "Texas",
                  "value": "Texas"
              }
          ],
          "validators": {}
        },
        {
          "name": "zip",
          "label": "Zip Code",
          "value": "",
          "type": "zip",
          "validators": {
            "required": true,
            "maxLength": 10,
            "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
          }
        }
      ]
    },
    "memberDetails": {
      "controls": [
        {
          "name": "mNamePrefix",
          "label":"Name Prefix",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 50
          }
        },
        {
          "name": "mFirstName",
          "label": "First Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 100
          }
        },
        {
          "name": "mMiddleName",
          "label": "Middle Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 50
          }
        },
        {
          "name": "mLastName",
          "label": "Last Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 100
          }
        },
        {
          "name": "mNameSuffix",
          "label": "Name Suffix",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 50
          }
        },
        {
          "name": "mDateOfBirth",
          "label": "Date of Birth",
          "value": "",
          "type": "date",
          "options": {
            "min": "1900-01-01",
            "max": "2100-01-01"
          },
          "validators": {
            "required": false
          }
        },
        {
          "name": "mGender",
          "label": "Gender",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 50
          }
        },
        {
          "name": "mOther",
          "label": "Other",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 100
          }
        },
        {
          "name": "mID",
          "label": "ID",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" :100
          }
        },
        {
          "name": "mSSN",
          "label": "SSN",
          "value": "",
          "type": "ssn",
          "validators": {
            "required": false,
            "ssn":true,
            "maxLength" : 11
          }
        },
        {
          "name": "mMedicaidId",
          "label": "Medicaid ID",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 100
          }
        },
        {
          "name": "mMedicareId",
          "label": "Medicare ID",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 100
          }
        },
        {
          "name": "mOtherId",
          "label": "Other ID",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 50
          }
        },
        {
          "name": "mPlan",
          "label": "Plan",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 100
          }
        },
        {
          "name": "mProgram",
          "label": "Program",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 100
          }
        },
        {
          "name": "mLOB",
          "label": "LOB",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 100
          }
        },
        {
          "name": "mGroup",
          "label": "Group",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 100
          }
        },
        {
          "name": "mAddress1",
          "label": "Street Address 1",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 100
          }
        },
        {
          "name": "mAddress2",
          "label": "Street Address 2",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 100
          }
        },
        {
          "name": "mCity",
          "label": "City",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength" : 50
          }
        },
        {
          "name": "mState",
          "label": "State/Territory",
          "value": "",
          "type": "select",
          "validators": {
            "required": false
          }
        },
        {
          "name": "mCounty",
          "label": "County",
          "value": "",
          "type": "select",
          "validators": {
            "required": false
          }
        },
        {
          "name": "mZip",
          "label": "Zip Code",
          "value": "",
          "type": "zip",
          "placeholder":"99999",
          "validators": {
            "required": false,
            "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)",
            "maxLength":10
          }
        },
        {
          "name": "mPrimaryPhone",
          "label": "Primary Phone",
          "value": "",
          "type": "text",
          "placeholder":"999-999-9999",
          "validators": {
              "required": false,
              "maxLength":50
          }
        },
        {
          "name": "mSecondaryPhone",
          "label": "Secondary Phone",
          "value": "",
          "type": "text",
          "placeholder":"999-999-9999",
          "validators": {
              "required": false,
              "maxLength":50
          }
        },
        {
          "name": "mEmail",
          "label": "Email",
          "value": "",
          "type": "email",
          "validators": {
            "email": true,
            "maxLength":100
          }
        }
      ]
    },
    "providerDetails":{
      "controls": [
          {
            "name": "pOrgName",
            "label": "Organization Name",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 150
            }
          },
          {
            "name": "pNamePrefix",
            "label": "Name Prefix",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 50
            }
          },
          {
            "name": "pFirstName",
            "label": "First Name",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pMiddleName",
            "label": "Middle Name",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 50
            }
          },
          {
            "name": "pLastName",
            "label": "Last Name",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pNameSuffix",
            "label": "Name Suffix",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 50
            }
          },
          {
            "name": "pDesignation",
            "label": "Designation/Title",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pDateOfBirth",
            "label": "Date Of Birth",
            "value": "",
            "type": "date",
            "options": {
            "min": "1900-01-01",
            "max": "2100-01-01"
          },
            "validators": {
              "required": false
            }
          },
          {
            "name": "pSsn",
            "label": "SSN",
            "value": "",
            "type": "ssn",
            "validators": {
            "required": false,
             "ssn":true,
             "maxLength" : 11,
             "regex" : "(^[0-9]{9}$)|(^[0-9]{3}-[0-9]{2}-[0-9]{4}$)"
            }
          },
          {
            "name": "pLicenseNo",
            "label": "License Number",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 50
            }
          },
          {
            "name": "pProviderID",
            "label": "ID",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pNPInumber",
            "label": "NPI",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 10
            }
          },
          {
            "name": "pTIN",
            "label": "TIN/EIN",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 11
            }
          },
          {
            "name": "pMedicaidId",
            "label": "Medicaid ID",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pMedicareId",
            "label": "Medicare ID",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pOtherId",
            "label": "Other ID",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 50
            }
          },
          {
            "name": "pType",
            "label": "Provider Type",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pSpecialty",
            "label": "Provider Specialty",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pTaxonomy",
            "label": "Taxonomy",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 30
            }
          },
          {
            "name": "pOther",
            "label": "Other",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pStreetAddress1",
            "label": "Street Address1",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pStreetAddress2",
            "label": "Street Address2",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pCity",
            "label": "City",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 50
            }
          },
          {
            "name": "pState",
            "label": "State/Territory",
            "value": "",
            "type": "select",
            "validators": {
              "required": false
            }
          },
          {
            "name": "pCounty",
            "label": "County/District",
            "value": "",
            "type": "select",
            "validators": {
              "required": false
            }
          },
          {
            "name": "pZip",
            "label": "Zip Code",
            "value": "",
            "type": "zip",
            "placeholder":"99999",
            "validators": {
              "required": false,
              "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)",
              "maxLength" : 10
            }
          },
          {
            "name": "pCountry",
            "label": "Country",
            "value": "",
            "type": "text",
            "validators": {
              "required": false,
              "maxLength" : 100
            }
          },
          {
            "name": "pPhone",
            "label": "Phone",
            "value": "",
            "type": "text",
            "placeholder":"999-999-9999",
            "validators": {
              "required": false,
              "maxLength" : 50
            }
          },
          {
            "name": "pFax",
            "label": "Fax",
            "value": "",
            "type": "fax",
            "placeholder":"999-999-9999",
            "validators": {
              "required": false,
              "fax":true,
              "maxLength" : 12
            }
          },
          {
            "name": "pEmail",
            "label": "Email",
            "value": "",
            "type": "email",
            "validators": {
              "email": true,
              "required": false,
              "maxLength" : 100
            }
          }
      ]
    },
    "nonEnumeratedProviderDetails":{
      "controls":[
        {
          "name": "nepOrgName",
          "label": "Organization Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "nepNamePrefix",
          "label": "Name Prefix",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50

          }
        },
        {
          "name": "nepFirstName",
          "label": "First Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100

          }
        },
        {
          "name": "nepMiddleName",
          "label": "Middle Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "nepLastName",
          "label": "Last Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "nepNameSuffix",
          "label": "Name Suffix",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "nepDesignation",
          "label": "Designation/Title",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "nepDateOfBirth",
          "label": "Date Of Birth",
          "value": "",
          "type": "date",
          "options": {
          "min": "1900-01-01",
          "max": "2100-01-01"
        },
          "validators": {
            "required": false
          }
        },
        {
          "name": "nepSsn",
          "label": "SSN",
          "value": "",
          "type": "ssn",
          "validators": {
            "required": false,
            "ssn":true,
            "maxLength":11
          }
        },
        {
          "name": "nepLicenseNo",
          "label": "License Number",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "nepOtherId",
          "label": "Other ID",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "nepOther",
          "label": "Other",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "nepPrimaryPhone",
          "label": "Primary Phone",
          "value": "",
          "type": "text",
          "placeholder":"999-999-9999",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "nepSecondaryPhone",
          "label": "Secondary Phone",
          "value": "",
          "type": "text",
          "placeholder":"999-999-9999",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "nepFax",
          "label": "Fax",
          "value": "",
          "type": "fax",
          "placeholder":"999-999-9999",
          "validators": {
            "required": false,
            "maxLength":12,
            "fax":true
          }
        },
        {
          "name": "nepEmail",
          "label": "Email",
          "value": "",
          "type": "email",
          "validators": {
            "email": true,
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "nepStreetAddress1",
          "label": "Street Address1",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "nepStreetAddress2",
          "label": "Street Address2",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "nepCity",
          "label": "City",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "nepState",
          "label": "State/Territory",
          "value": "",
          "type": "select",
          "validators": {
            "required": false
          }
        },
        {
          "name": "nepCounty",
          "label": "County/District",
          "value": "",
          "type": "select",
          "validators": {
            "required": false
          }
        },
        {
          "name": "nepZip",
          "label": "Zip",
          "value": "",
          "type": "zip",
          "placeholder":"99999",
          "validators": {
            "required": false,
            "maxLength":10,
            "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
          }
        },
        {
          "name": "nepCountry",
          "label": "Country",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        }
      ]
    },
    "nonEnumeratedOrganizationDetails":{
      "controls":[
        {
          "name": "neoOrgName",
          "label": "Organization Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "neoTIN",
          "label": "TIN/EIN",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":11
          }
        },
        {
          "name": "neoLicenseNo",
          "label": "License Number",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neoOther",
          "label": "Other",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "neoOtherId",
          "label": "Other ID",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neoContactNamePrefix",
          "label": "Contact Name Prefix",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neoContactFirstName",
          "label": "Contact First Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "neoContactMiddleName",
          "label": "Contact Middle Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neoContactLastName",
          "label": "Contact Last Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100

          }
        },
        {
          "name": "neoContactDesignation",
          "label": "Contact Designation/Title",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100

          }
        },
        {
          "name": "neoStreetAddress1",
          "label": "Street Address1",
          "value": "",
          "type": "text",
          "validators": {
            "maxLength":100,
            "required": false
          }
        },
        {
          "name": "neoStreetAddress2",
          "label": "Street Address2",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "neoCity",
          "label": "City",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neoState",
          "label": "State/Territory",
          "value": "",
          "type": "select",
          "validators": {
            "required": false
          }
        },
        {
          "name": "neoCounty",
          "label": "County/District",
          "value": "",
          "type": "select",
          "validators": {
            "required": false
          }
        },
        {
          "name": "neoZip",
          "label": "Zip",
          "value": "",
          "type": "zip",
          "placeholder":"99999",
          "validators": {
            "required": false,
            "maxLength":10,
            "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
          }
        },
        {
          "name": "neoCountry",
          "label": "Country",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "neoPhone",
          "label": "Phone",
          "value": "",
          "type": "text",
          "placeholder":"999-999-9999",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neoFax",
          "label": "Fax",
          "value": "",
          "type": "fax",
          "placeholder":"999-999-9999",
          "validators": {
            "required": false,
            "maxLength":12,
            "fax":true
          }
        },
        {
          "name": "neoEmail",
          "label": "Email",
          "value": "",
          "type": "email",
          "validators": {
            "required": false,
            "email": true,
            "maxLength":100
          }
        }
      ]
    },
    "nonEnumeratedIndividualDetails":{
      "controls":[
        {
          "name": "neiAssociatedOrg",
          "label":"Associated Organization Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "neiNamePrefix",
          "label":"Name Prefix",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neiFirstName",
          "label": "First Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "neiMiddleName",
          "label": "Middle Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neiLastName",
          "label": "Last Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "neiNameSuffix",
          "label": "Name Suffix",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neiDesignation",
          "label": "Designation/Title",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "neiDateOfBirth",
          "label": "Date Of Birth",
          "value": "",
          "type": "date",
          "options": {
          "min": "1900-01-01",
          "max": "2100-01-01"
        },
          "validators": {
            "required": false
          }
        },
        {
          "name": "neiSsn",
          "label": "SSN",
          "value": "",
          "type": "ssn",
          "validators": {
            "required": false,
            "maxLength":11,
            "ssn":true
          }
        },
        {
          "name": "neiOtherId",
          "label": "Other ID",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neiOther",
          "label": "Other",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "neiStreetAddress1",
          "label": "Street Address1",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
            
          }
        },
        {
          "name": "neiStreetAddress2",
          "label": "Street Address2",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100

          }
        },
        {
          "name": "neiCity",
          "label": "City",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":50

          }
        },
        {
          "name": "neiState",
          "label": "State/Territory",
          "value": "",
          "type": "select",
          "validators": {
            "required": false
          }
        },
        {
          "name": "neiCounty",
          "label": "County/District",
          "value": "",
          "type": "select",
          "validators": {
            "required": false
          }
        },
        {
          "name": "neiZip",
          "label": "Zip Code",
          "value": "",
          "type": "zip",
          "placeholder":"99999",
          "validators": {
            "required": false,
            "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)",
            "maxLength":10
          }
        },
        {
          "name": "neiCountry",
          "label": "Country",
          "value": "",
          "type": "text",
          "validators": {
            "required": false,
            "maxLength":100
          }
        },
        {
          "name": "neiPrimaryPhone",
          "label": "Primary Phone",
          "value": "",
          "type": "text",
          "placeholder":"999-999-9999",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neiSecondaryPhone",
          "label": "Secondary Phone",
          "value": "",
          "type": "text",
          "placeholder":"999-999-9999",
          "validators": {
            "required": false,
            "maxLength":50
          }
        },
        {
          "name": "neiEmail",
          "label": "Email",
          "value": "",
          "type": "email",
          "validators": {
            "required": false,
            "maxLength":100,
            "email": true
          }
        }
      ]
    },
    "serviceLocationDetails": {
      "controls": [
        {
          "name": "sAddress1",
          "label": "Service Location Street Address Line 1",
          "value": "",
          "type": "text",
          "validators": {
            "required": true
          }
        },
        {
          "name": "sAddress2",
          "label": "Service Location Street Address Line 2",
          "value": "",
          "type": "text",
          "validators": {
            "required": false
          }
        },
        {
          "name": "sCity",
          "label": "Service Location City",
          "value": "",
          "type": "text",
          "validators": {
            "required": true
          }
        },
        {
          "name": "sState",
          "label": "Service Location State",
          "value": "",
          "type": "select",
          "options": [
            {
              "key": "test",
              "value": "texas"
            }
          ],
          "validators": {
            "required": true
          }
        },
        {
          "name": "sCounty",
          "label": "Service Location County",
          "value": "",
          "type": "select",
          "options": [
            {
              "key": "test",
              "value": "test"
            }
          ],
          "validators": {
            "required": false 
          }
        },
        {
          "name": "sZip",
          "label": "Service Location ZIP",
          "value": "",
          "type": "zip",
          "validators": {
            "required": true,
            "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
          }
        },
        {
          "name": "sPhoneNumber",
          "label": "Phone Number",
          "value": "",
          "type": "text",
          "validators": {
              "required": false
          }
        },
        {
          "name": "sFax",
          "label": "Fax Number",
          "value": "",
          "type": "text",
          "validators": {
            "required": true
          }
        },
        {
          "name": "sEmail",
          "label": "Email Address",
          "value": "",
          "type": "email",
          "validators": {
            "required": false
          }
        }
      ]
    },
    "validateParticipant": {
      "controls": [
        {
          "name": "vpIsParticipant",
          "label": "Does this referral involve a specific Participant?",
          "value": "",
          "type": "select",
          "options": [
            {
                "key": "Yes",
                "value": "Yes"
            },
            {
              "key": "No",
              "value": "No"
            }
          ],
          "validators": {
            "required": true
          }
        }        
      ],
      "subcontrols": [
        {
          "name": "vpIsreferring",
          "label": "Was the Participant also the witness or external referring party?",
          "value": "",
          "type": "select",
          "options": [
            {
                "key": "Yes",
                "value": "Yes"
            },
            {
              "key": "No",
              "value": "No"
            }
          ],
          "validators": {
            "required": true
          }
        }
      ]
    },
    "participantDetails": {
      "controls": [
        {
          "name": "paFirstName",
          "label": "Participant First Name",
          "value": "",
          "type": "text",
          "validators": {
            "required": false
          }
        },
        {
          "name": "paLastName",
          "label": "Participant Last Name",
          "value": "",
          "type": "text",
          "validators": {
              "required": false
          }
        },
        {
          "name": "paID",
          "label": "ID",
          "value": "",
          "type": "text",
          "validators": {
              "required": false
          }
        },
        {
          "name": "paDOB",
          "label": "Date of Birth",
          "value": "",
          "type": "date",
          "options": {
            "min": "1900-01-01",
            "max": "2100-01-01"
          },
          "validators": {
              "required": false
          }
        },
        {
          "name": "paPlanType",
          "label": "Program/Plan Type",
          "value": "",
          "type": "text",
          "validators": {
              "required": false
          }
        },
        {
          "name": "paPhone",
          "label": "Phone Number",
          "value": "",
          "type": "text",
          "validators": {
              "required": false
          }
        },
        {
          "name": "paEmail",
          "label": "Email",
          "value": "",
          "type": "email",
          "validators": {
              "email": false
          }
        },
        {
          "name": "paAddress1",
          "label": "Street Address 1",
          "value": "",
          "type": "text",
          "validators": {
            "required": false
          }
        },
        {
          "name": "paAddress2",
          "label": "Street Address 2",
          "value": "",
          "type": "text",
          "validators": {
          }
        },
        {
          "name": "paCity",
          "label": "City",
          "value": "",
          "type": "text",
          "validators": {
            "required": false
          }
        },
        {
          "name": "paState",
          "label": "State",
          "value": "",
          "type": "select",
          "options": [
              {
                  "key": "Texas",
                  "value": "Texas"
              }
          ],
          "validators": {
            "required": false
          }
        },
        {
          "name": "paCounty",
          "label": "County",
          "value": "",
          "type": "select",
          "options": [
          ],
          "validators": {
            "required": false
          }
        },
        {
        "name": "paZip",
        "label": "Zip",
        "value": "",
        "type": "zip",
        "validators": {
          "required": false,
          "maxLength": 10,
          "regex": "(^[0-9]{5}$)|(^[0-9]{9}$)|(^[0-9]{5}-[0-9]{4}$)"
        }
      },
      {
        "name": "paCountry",
        "label": "Country",
        "value": "",
        "type": "text",
        "validators": {
          "required": false
        }
      }
      ]
    },
    "summaryDetails": {
      "controls": [
        {
          "name": "summary",
          "label": "Describe any issue(s) or allegation(s), including details such the involved procedure/diagnosis codes and descriptions, violation(s) of regulations, etc.",
          "value": "",
          "type": "textarea",
          "maxlength": 4000,
          "options": {
            "showCount":true,
            "count": 0
          },
          "validators": {
            "required": true,
            "maxLength": 4000
          }
      }
      ]
    },
    "questionsDetails": {
      "InternalLeadQuestionKey": "1",
      "PayorKey": "5",
      "Question1": "Does this involve a MA recipient?",
      "IsQuestion1Active": "1",
      "IsQuestion1DisplayUnknown": "1",
      "IsQuestion1DisplayText": "0",
      "IsQuestion1DisplayTextRequired": "1",
      "Question2": "Did the MCO recover any amount? If yes, please list the amount of money recovered to date in the text box below:",
      "IsQuestion2Active": "1",
      "IsQuestion2DisplayUnknown": "1",
      "IsQuestion2DisplayText": "1",
      "IsQuestion2DisplayTextRequired": "0",
      "Question3": "Were claims reviewed? ",
      "IsQuestion3Active": "1",
      "IsQuestion3DisplayUnknown": "1",
      "IsQuestion3DisplayText": "0",
      "IsQuestion3DisplayTextRequired": "0",
      "Question4": "Date(s)/Date Range of Claims Reviewed (if any):",
      "IsQuestion4Active": "1",
      "IsQuestion4DisplayUnknown": "0",
      "IsQuestion4DisplayText": "1",
      "IsQuestion4DisplayTextRequired": "0",
      "Question5": "Please list the number of claims reviewed (if any):",
      "IsQuestion5Active": "1",
      "IsQuestion5DisplayUnknown": "0",
      "IsQuestion5DisplayText": "1",
      "IsQuestion5DisplayTextRequired": "0",
      "Question6": "Describe in as much detail as possible what findings resulted from the claims review:",
      "IsQuestion6Active": "1",
      "IsQuestion6DisplayUnknown": "0",
      "IsQuestion6DisplayText": "1",
      "IsQuestion6DisplayTextRequired": "0",
      "Question7": "Were medical records reviewed?",
      "IsQuestion7Active": "1",
      "IsQuestion7DisplayUnknown": "1",
      "IsQuestion7DisplayText": "0",
      "IsQuestion7DisplayTextRequired": "0",
      "Question8": "Please list the date range of medical records reviewed (if any):",
      "IsQuestion8Active": "1",
      "IsQuestion8DisplayUnknown": "0",
      "IsQuestion8DisplayText": "1",
      "IsQuestion8DisplayTextRequired": "0",
      "Question9": "Please list the number of medical records reviewed (if any):",
      "IsQuestion9Active": "1",
      "IsQuestion9DisplayUnknown": "0",
      "IsQuestion9DisplayText": "1",
      "IsQuestion9DisplayTextRequired": "0",
      "Question10": "Are medical records being submitted to BPI?",
      "IsQuestion10Active": "1",
      "IsQuestion10DisplayUnknown": "1",
      "IsQuestion10DisplayText": "0",
      "IsQuestion10DisplayTextRequired": "0",
      "Question11": "Was the provider interviewed?",
      "IsQuestion11Active": "1",
      "IsQuestion11DisplayUnknown": "1",
      "IsQuestion11DisplayText": "0",
      "IsQuestion11DisplayTextRequired": "0",
      "Question12": "If the provider was interviewed, please describe as much detail as possible the findings from the interview(s):",
      "IsQuestion12Active": "1",
      "IsQuestion12DisplayUnknown": "0",
      "IsQuestion12DisplayText": "1",
      "IsQuestion12DisplayTextRequired": "0",
      "Question13": "Was the provider's staff interviewed?",
      "IsQuestion13Active": "1",
      "IsQuestion13DisplayUnknown": "1",
      "IsQuestion13DisplayText": "0",
      "IsQuestion13DisplayTextRequired": "0",
      "Question14": "If the provider's staff was interviewed, please describe as much detail as possible the findings from the interview(s):",
      "IsQuestion14Active": "1",
      "IsQuestion14DisplayUnknown": "0",
      "IsQuestion14DisplayText": "1",
      "IsQuestion14DisplayTextRequired": "0",
      "Question15": "Were recipients interviewed?",
      "IsQuestion15Active": "1",
      "IsQuestion15DisplayUnknown": "1",
      "IsQuestion15DisplayText": "0",
      "IsQuestion15DisplayTextRequired": "0",
      "Question16": "If recipients were interviewed, please describe as much detail as possible the findings from the interview(s):",
      "IsQuestion16Active": "1",
      "IsQuestion16DisplayUnknown": "0",
      "IsQuestion16DisplayText": "1",
      "IsQuestion16DisplayTextRequired": "0",
      "Question17": "Is there any other relevant information or case outcome?",
      "IsQuestion17Active": "1",
      "IsQuestion17DisplayUnknown": "1",
      "IsQuestion17DisplayText": "0",
      "IsQuestion17DisplayTextRequired": "0",
      "Question18": "Please describe any other relevant information or case outcome:",
      "IsQuestion18Active": "1",
      "IsQuestion18DisplayUnknown": "0",
      "IsQuestion18DisplayText": "1",
      "IsQuestion18DisplayTextRequired": "0",
      "Question19": "In accordance with the HealthChoices Agreement, all supporting documentation as required on the Checklist of Supporting Documentation for Referrals, including relevant claims, medical records, and other supporting documentation has been downloaded to the appropriate MCO folder on DocuShare. All incomplete referrals will be rejected and considered in breach/violation of the requirements listed in the HealthChoices Agreement and noted on the MCO Quarterly Compliance Report.",
      "IsQuestion19Active": "1",
      "IsQuestion19DisplayUnknown": "1",
      "IsQuestion19DisplayText": "0",
      "IsQuestion19DisplayTextRequired": "0",
      "Question20": "Question 20",
      "IsQuestion20Active": "0",
      "IsQuestion20DisplayUnknown": "1",
      "IsQuestion20DisplayText": "1",
      "IsQuestion20DisplayTextRequired": "1",
      "Question21": "Question 21",
      "IsQuestion21Active": "1",
      "IsQuestion21DisplayUnknown": "1",
      "IsQuestion21DisplayText": "1",
      "IsQuestion21DisplayTextRequired": "1",
      "Question22": "Question 22",
      "IsQuestion22Active": "0",
      "IsQuestion22DisplayUnknown": "1",
      "IsQuestion22DisplayText": "0",
      "IsQuestion22DisplayTextRequired": "1",
      "Question23": "Question 23",
      "IsQuestion23Active": "0",
      "IsQuestion23DisplayUnknown": "1",
      "IsQuestion23DisplayText": "1",
      "IsQuestion23DisplayTextRequired": "1",
      "Question24": "Question 24",
      "IsQuestion24Active": "0",
      "IsQuestion24DisplayUnknown": "1",
      "IsQuestion24DisplayText": "1",
      "IsQuestion24DisplayTextRequired": "1",
      "Question25": "Question 25",
      "IsQuestion25Active": "0",
      "IsQuestion25DisplayUnknown": "1",
      "IsQuestion25DisplayText": "1",
      "IsQuestion25DisplayTextRequired": "1",
      "Question26": "Question 26",
      "IsQuestion26Active": "0",
      "IsQuestion26DisplayUnknown": "1",
      "IsQuestion26DisplayText": "1",
      "IsQuestion26DisplayTextRequired": "1",
      "Question27": "Question 27",
      "IsQuestion27Active": "0",
      "IsQuestion27DisplayUnknown": "1",
      "IsQuestion27DisplayText": "1",
      "IsQuestion27DisplayTextRequired": "1",
      "Question28": "Question 28",
      "IsQuestion28Active": "0",
      "IsQuestion28DisplayUnknown": "1",
      "IsQuestion28DisplayText": "1",
      "IsQuestion28DisplayTextRequired": "1",
      "Question29": "Question 29",
      "IsQuestion29Active": "0",
      "IsQuestion29DisplayUnknown": "1",
      "IsQuestion29DisplayText": "1",
      "IsQuestion29DisplayTextRequired": "1",
      "Question30": "Question 30",
      "IsQuestion30Active": "0",
      "IsQuestion30DisplayUnknown": "1",
      "IsQuestion30DisplayText": "1",
      "IsQuestion30DisplayTextRequired": "1",
      "IsEnabled": "1"
  },
    "agreementDetails": {
      "controls": [
        {
          "name": "agreement",
          "label": "",
          "value": "",
          "type": "select",
          "options": [
              {
                  "key": "YES",
                  "value": "YES"
              },
              {
                "key": "NO",
                "value": "NO"
            }
          ],
          "validators": {
            "required": true
          }
        }
      ]
    },
    "finalDetails": {
      "controls": [
        {
          "name": "thanksQuote",
          "label": "Your management skills and work ethic made a lasting impression on me at the beginning of my career. Under your guidance, I learned how to be a better leader and a person that everyone can count on. \nThank you for your referral. I will never forget your kindness",
          "value": "",
          "type": "label"
        }
      ]
    }
}